import { useState } from "react";
import { switchPositionBlockTyrPC } from "../fnHelperTyr";
import "../style.css";
import { ModalTyr } from "./ModalTyr";
import iconTyr from "./360 tour.svg";

const ButtonTyrRooms = ({ props }) => {
  const [ModalStatusTyr, setModalStatusTyr] = useState(false);

  return (
    <>
      <button
        style={switchPositionBlockTyrPC(props?.images)}
        onClick={() => setModalStatusTyr(true)}
        className="buttonTyr"
      >
        <img src={iconTyr} />
      </button>
      <ModalTyr
        room_type_panorama={props?.result?.room_type_panorama}
        ModalStatusTyr={ModalStatusTyr}
        setModalStatusTyr={setModalStatusTyr}
      />
    </>
  );
};

export { ButtonTyrRooms };
